import React, { FC } from "react";

import { Trans } from "react-i18next";

import Typography from "components/BaseComponents/Typography";

import { DIGIPOSTHEME } from "theme/digiPosTheme";

import { StyledInnerContainer } from "./InfoWarning.styles";
import { Col, Row } from "components/BaseComponents/Flex";

const InfoWarning: FC = () => {
  return (
    <StyledInnerContainer className='theme-layout-background' margin='15px 0'>
      <Col>
        <Row
          backgroundColor={DIGIPOSTHEME.colors.secondaryWhite}
          justifyContent='center'
          alignItems='center'
        >
          <Typography
            align='center'
            color={DIGIPOSTHEME.colors.secondaryAkbankBlack}
            letterSpacing='0.23px'
            size='18px'
            transform='uppercase'
            variant='span'
            weight='800'
            display='flex'
          >
            <Trans i18nKey='global_warning' />
          </Typography>
        </Row>
        <Row
          backgroundColor={DIGIPOSTHEME.colors.secondaryWhite}
          justifyContent='center'
          alignItems='center'
        >
          <Typography
            width='100%'
            align='center'
            color={DIGIPOSTHEME.colors.secondaryAkbankBlack}
            letterSpacing='0.23px'
            size='16px'
            transform='none'
            variant='span'
            weight='600'
            display='flex'
          >
            <Trans i18nKey='InfoWarning_Bold' />
          </Typography>
        </Row>
        <Row
          backgroundColor={DIGIPOSTHEME.colors.secondaryWhite}
          justifyContent='center'
          alignItems='center'
        >
          <Typography
            width='100%'
            align='center'
            color={DIGIPOSTHEME.colors.secondaryGraySecondary}
            letterSpacing='0.23px'
            size='16px'
            transform='none'
            variant='span'
            weight='500'
            display='flex'
          >
            <Trans i18nKey='InfoWarning_normal' />
          </Typography>
        </Row>
      </Col>
    </StyledInnerContainer>
  );
};

export default InfoWarning;
